import { registerLocaleData } from '@angular/common';
import localeEnGb from '@angular/common/locales/en-GB';
import { isUsaPmsEnvironment } from './pms-dashboard-path.util';

registerLocaleData(localeEnGb);

export type PmsDateLocale = 'en-US' | 'en-GB';

export type PmsDateToken =
  | 'shortDate'
  | 'longDate'
  | 'dateTime'
  | 'longDateTime'
  | 'mediumDateTime'
  | 'monthDay'
  | 'monthDayShortYear'
  | 'signedDateTime'
  | 'timeOnly';

const UK_DATE_FORMATS: Record<PmsDateToken, string> = {
  shortDate: 'dd-MM-yyyy',
  longDate: 'd MMM, yyyy',
  dateTime: 'dd-MM-yyyy, h:mm a',
  longDateTime: 'd MMM, yyyy h:mm a',
  mediumDateTime: 'medium',
  monthDay: 'd MMM',
  monthDayShortYear: 'd MMM yy',
  signedDateTime: "d MMM y 'at' h:mma z",
  timeOnly: 'h:mm a',
};

const US_DATE_FORMATS: Record<PmsDateToken, string> = {
  shortDate: 'MM-dd-yyyy',
  longDate: 'MMM d, yyyy',
  dateTime: 'MM-dd-yyyy, h:mm a',
  longDateTime: 'MMM d, yyyy h:mm a',
  mediumDateTime: 'medium',
  monthDay: 'MMM d',
  monthDayShortYear: 'MMM d yy',
  signedDateTime: "MMM d, y 'at' h:mma z",
  timeOnly: 'h:mm a',
};

export function getPmsLocale(): PmsDateLocale {
  return isUsaPmsEnvironment() ? 'en-US' : 'en-GB';
}

export function getPmsDateFormat(token: PmsDateToken): string {
  return (isUsaPmsEnvironment() ? US_DATE_FORMATS : UK_DATE_FORMATS)[token];
}
